export {MFRuntime, MFSDK} from 'src/helper/moduleFederation'
